export const PAYMENT_LABEL: any = {
    'United States': {
      nameCard: 'Name on Card',
      cardType: 'Card Type',
      cardNumber: 'Card Number',
      expirationDate: 'Expiration Date',
      monthDate: 'Month',
      monthDateTC: 'Expiration Month',
      yearDate: 'Year',
      yearDateTC: 'Expiration Year',
      expirationDateLabel: '(MM/YYYY)',
      expirationDateLabelBT: '(MM/YY)',
      cvv: 'CVV2',
      cvvTC: 'Security Code',
      whatsThis: 'What is this?',
    },
    'Germany': {
      nameCard: 'Name auf der Karte',
      cardType: 'Speicherkarten-Typ',
      cardNumber: 'Kartennummer',
      expirationDate: 'Verfallsdatum',
      monthDate: 'Monat',
      yearDate: 'Jahr',
      expirationDateLabel: '(MM/JJJJ)',
      expirationDateLabelBT: '(MM/JJ)',
      cvv: 'CVV2',
      whatsThis: 'Was ist das?',
    },
    'Mexico': {
      nameCard: 'Nombre en la tarjeta',
      cardType: 'Tipo de tarjeta',
      cardNumber: 'Número de tarjeta',
      expirationDate: 'Fecha de caducidad',
      monthDate: 'Mes',
      yearDate: 'Año',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: '¿Qué es esto?',
    },
    'Russia': {
      nameCard: 'Имя на карте',
      cardType: 'Тип карты',
      cardNumber: 'Номер карты  ',
      expirationDate: 'Срок действия',
      monthDate: 'Месяц',
      yearDate: 'Год',
      expirationDateLabel: '(ММ/ГГГГ)',
      expirationDateLabelBT: '(ММ/ГГ)',
      cvv: 'CVV2',
      whatsThis: 'Что это?',
    },
    'China': {
      nameCard: '卡上的名字',
      cardType: '卡类型',
      cardNumber: '卡号',
      expirationDate: '有效期',
      monthDate: '月',
      yearDate: '年',
      expirationDateLabel: '(MM/YYYY)',
      expirationDateLabelBT: '(MM/YY)',
      cvv: 'CVV2',
      whatsThis: '这是什么？',
    },
    'Austria': {
      nameCard: 'Name auf der Karte',
      cardType: 'Kartentyp',
      cardNumber: 'Kartennummer',
      expirationDate: 'Ablaufdatum',
      monthDate: 'Monat',
      yearDate: 'Jahr',
      expirationDateLabel: '(MM/JJJJ)',
      expirationDateLabelBT: '(MM/JJ)',
      cvv: 'CVV2',
      whatsThis: 'Was ist das?',
    },
    'Belgium': {
      nameCard: 'Naam op kaart',
      cardType: 'Kaarttype',
      cardNumber: 'Kaartnummer',
      expirationDate: 'Vervaldatum',
      monthDate: 'Maand',
      yearDate: 'Jaar',
      expirationDateLabel: '(MM/JJJJ)',
      expirationDateLabelBT: '(MM/JJ)',
      cvv: 'CVV2',
      whatsThis: 'Wat is dit?',
    },
    'Bulgaria': {
      nameCard: 'Име на картата',
      cardType: 'Тип на картата',
      cardNumber: 'Номер на картата',
      expirationDate: 'Срок на годност',
      monthDate: 'Месец',
      yearDate: 'Година',
      expirationDateLabel: '(ММ/ГГГГ)',
      expirationDateLabelBT: '(ММ/ГГ)',
      cvv: 'CVV2',
      whatsThis: 'Какво е това?',
    },
    'Croatia': {
      nameCard: 'Ime na kartici',
      cardType: 'Vrsta kartice',
      cardNumber: 'Broj kart  ',
      expirationDate: 'Datum isteka',
      monthDate: 'Mjesec',
      yearDate: 'Godina',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'Što je ovo?',
    },
    'Cyprus': {
      nameCard: 'Όνομα στην κάρτα',
      cardType: 'Τύπος κάρτας',
      cardNumber: 'Αριθμός κάρτας',
      expirationDate: 'Ημερομηνία λήξης',
      monthDate: 'Μήνας',
      yearDate: 'Έτος',
      expirationDateLabel: '(ΜΜ/ΕΕΕΕ)',
      expirationDateLabelBT: '(ΜΜ/ΕΕ)',
      cvv: 'CVV2',
      whatsThis: 'Τι είναι αυτό;',
    },
    'Czech Republic': {
      nameCard: 'Jméno na kartě',
      cardType: 'Typ karty',
      cardNumber: 'Číslo karty',
      expirationDate: 'Datum expirace',
      monthDate: 'Měsíc',
      yearDate: 'Rok',
      expirationDateLabel: '(MM/RRRR)',
      expirationDateLabelBT: '(MM/RR)',
      cvv: 'CVV2',
      whatsThis: 'Co je to?',
    },
    'Denmark': {
      nameCard: 'Navn på kort',
      cardType: 'Korttype',
      cardNumber: 'Kortnummer',
      expirationDate: 'Udløbsdato',
      monthDate: 'Måned',
      yearDate: 'År',
      expirationDateLabel: '(MM/ÅÅÅÅ)',
      expirationDateLabelBT: '(MM/ÅÅ)',
      cvv: 'CVV2',
      whatsThis: 'Hvad er dette?',
    },
    'Estonia': {
      nameCard: 'Nimi kaardil',
      cardType: 'Kaarditüüp',
      cardNumber: 'Kaardi number',
      expirationDate: 'Aegumiskuupäev',
      monthDate: 'Kuu',
      yearDate: 'Aasta',
      expirationDateLabel: '(KK/AAAA)',
      expirationDateLabelBT: '(KK/AA)',
      cvv: 'CVV2',
      whatsThis: 'Mis see on?',
    },
    'Finland': {
      nameCard: 'Nimi kortissa',
      cardType: 'Kortin tyyppi',
      cardNumber: 'Kortin numero',
      expirationDate: 'Vanhenemispäivä',
      monthDate: 'Kuukausi',
      yearDate: 'Vuosi',
      expirationDateLabel: '(KK/VVVV)',
      expirationDateLabelBT: '(KK/VV)',
      cvv: 'CVV2',
      whatsThis: 'Mikä tämä on?',
    },
    'France': {
      nameCard: 'Nom sur la carte',
      cardType: 'Type de carte',
      cardNumber: 'Numéro de carte',
      expirationDate: 'Date d\'expiration',
      monthDate: 'Mois',
      yearDate: 'Année',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'Qu\'est-ce que c\'est?',
    },
    'Greece': {
      nameCard: 'Όνομα στην κάρτα',
      cardType: 'Τύπος κάρτας',
      cardNumber: 'Αριθμός κάρτας',
      expirationDate: 'Ημερομηνία λήξης',
      monthDate: 'Μήνας',
      yearDate: 'Έτος',
      expirationDateLabel: '(ΜΜ/ΕΕΕΕ)',
      expirationDateLabelBT: '(ΜΜ/ΕΕ)',
      cvv: 'CVV2',
      whatsThis: 'Τι είναι αυτό;',
    },
    'Hungary': {
      nameCard: 'Név a kártyán',
      cardType: 'Kártyatípus',
      cardNumber: 'Kártyaszám',
      expirationDate: 'Lejárati dátum',
      monthDate: 'Hónap',
      yearDate: 'Év',
      expirationDateLabel: '(HH/ÉÉÉÉ)',
      expirationDateLabelBT: '(HH/ÉÉ)',
      cvv: 'CVV2',
      whatsThis: 'Mi ez?',
    },
    'Italy': {
      nameCard: 'Nome sulla carta',
      cardType: 'Tipo di carta',
      cardNumber: 'Numero di carta',
      expirationDate: 'Data di scadenza',
      monthDate: 'Mese',
      yearDate: 'Anno',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'Cos\'è questo?',
    },
    'Latvia': {
      nameCard: 'Vārds uz kartes',
      cardType: 'Kartes tips',
      cardNumber: 'Kartes numurs',
      expirationDate: 'Derīguma termiņš',
      monthDate: 'Mēnesis',
      yearDate: 'Gads',
      expirationDateLabel: '(MM/GGGG)',
      expirationDateLabelBT: '(MM/GG)',
      cvv: 'CVV2',
      whatsThis: 'Kas tas ir?',
    },
    'Lithuania': {
      nameCard: 'Vardas kortelėje',
      cardType: 'Kortelės tipas',
      cardNumber: 'Kortelės numeris',
      expirationDate: 'Galiojimo data',
      monthDate: 'Mėnuo',
      yearDate: 'Metai',
      expirationDateLabel: '(MM/GGGG)',
      expirationDateLabelBT: '(MM/GG)',
      cvv: 'CVV2',
      whatsThis: 'Kas tai?',
    },
    'Luxembourg': {
      nameCard: 'Nom sur la carte',
      cardType: 'Type de carte',
      cardNumber: 'Numéro de carte',
      expirationDate: 'Date d\'expiration',
      monthDate: 'Mois',
      yearDate: 'Année',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'Qu\'est-ce que c\'est?',
    },
    'Malta': {
      nameCard: 'Isem fuq il-Karta',
      cardType: 'Tip ta \'Karta',
      cardNumber: 'Numru tal-Karta',
      expirationDate: 'Data ta \'Skadenza',
      monthDate: 'Xahar',
      yearDate: 'Sena',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'X\'inhuma?',
    },
    'The Netherlands': {
      nameCard: 'Naam op kaart',
      cardType: 'Kaarttype',
      cardNumber: 'Kaartnummer',
      expirationDate: 'Vervaldatum',
      monthDate: 'Maand',
      yearDate: 'Jaar',
      expirationDateLabel: '(MM/JJJJ)',
      expirationDateLabelBT: '(MM/JJ)',
      cvv: 'CVV2',
      whatsThis: 'Wat is dit?',
    },
    'Poland': {
      nameCard: 'Nazwa na karcie',
      cardType: 'Typ karty',
      cardNumber: 'Numer karty  ',
      expirationDate: 'Data ważności',
      monthDate: 'Miesiąc',
      yearDate: 'Rok',
      expirationDateLabel: '(MM/RRRR)',
      expirationDateLabelBT: '(MM/RR)',
      cvv: 'CVV2',
      whatsThis: 'Co to jest?',
    },
    'Portugal': {
      nameCard: 'Nome no cartão',
      cardType: 'Tipo de cartão',
      cardNumber: 'Número do cartão',
      expirationDate: 'Data de validade',
      monthDate: 'Mês',
      yearDate: 'Ano',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'O que é isso?',
    },
    'Romania': {
      nameCard: 'Nume pe card',
      cardType: 'Tip de card',
      cardNumber: 'Număr de card',
      expirationDate: 'Data de expirare',
      monthDate: 'Luna',
      yearDate: 'An',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'Ce este asta?',
    },
    'Slovakia': {
      nameCard: 'Meno na karte',
      cardType: 'Typ karty',
      cardNumber: 'Číslo karty',
      expirationDate: 'Dátum exspirácie',
      monthDate: 'Mesiac',
      yearDate: 'Rok',
      expirationDateLabel: '(MM/RRRR)',
      expirationDateLabelBT: '(MM/RR)',
      cvv: 'CVV2',
      whatsThis: 'Čo je to?',
    },
    'Slovenia': {
      nameCard: 'Ime na kartici',
      cardType: 'Vrsta kartice',
      cardNumber: 'Broj kart',
      expirationDate: 'Datum isteka',
      monthDate: 'Mjesec',
      yearDate: 'Godina',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'Što je ovo?',
    },
    'Spain': {
      nameCard: 'Nombre en la tarjeta',
      cardType: 'Tipo de tarjeta',
      cardNumber: 'Número de tarjeta',
      expirationDate: 'Fecha de caducidad',
      monthDate: 'Mes',
      yearDate: 'Año',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: '¿Qué es esto?',
    },
    'Sweden': {
      nameCard: 'Namn på kortet',
      cardType: 'Korttyp',
      cardNumber: 'Kortnummer',
      expirationDate: 'Utgångsdatum',
      monthDate: 'Månad',
      yearDate: 'År',
      expirationDateLabel: '(MM/ÅÅÅÅ)',
      expirationDateLabelBT: '(MM/ÅÅ)',
      cvv: 'CVV2',
      whatsThis: 'Vad är detta?',
    },
    'Japan': {
      nameCard: 'カード上の名前',
      cardType: 'カードの種類',
      cardNumber: 'カード番号',
      expirationDate: '有効期限',
      monthDate: '月',
      yearDate: '年',
      expirationDateLabel: '(MM/YYYY)',
      expirationDateLabelBT: '(MM/YY)',
      cvv: 'CVV2',
      whatsThis: 'これは何ですか？',
    },
    'Switzerland': {
      nameCard: 'Name auf Karte',
      cardType: 'Kartentyp',
      cardNumber: 'Kartennummer',
      expirationDate: 'Ablaufdatum',
      monthDate: 'Monat',
      yearDate: 'Jahr',
      expirationDateLabel: '(MM/JJJJ)',
      expirationDateLabelBT: '(MM/JJ)',
      cvv: 'CVV2',
      whatsThis: 'Was ist das?',
    },
    'Hong Kong': {
      nameCard: '卡上的名字',
      cardType: '卡类型',
      cardNumber: '卡号',
      expirationDate: '有效期',
      monthDate: '月',
      yearDate: '年',
      expirationDateLabel: '(MM/YYYY)',
      expirationDateLabelBT: '(MM/YY)',
      cvv: 'CVV2',
      whatsThis: '这是什么？',
    },
    'Taiwan': {
      nameCard: '卡上的名字',
      cardType: '卡类型',
      cardNumber: '卡号',
      expirationDate: '有效期',
      monthDate: '月',
      yearDate: '年',
      expirationDateLabel: '(MM/YYYY)',
      expirationDateLabelBT: '(MM/YY)',
      cvv: 'CVV2',
      whatsThis: '这是什么？',
    },
    'Iceland': {
      nameCard: 'Nafn á korti',
      cardType: 'Kortategund',
      cardNumber: 'Kortanúmer',
      expirationDate: 'Gildistími',
      monthDate: 'Mánuður',
      yearDate: 'Ár',
      expirationDateLabel: '(MM/ÁÁÁÁ)',
      expirationDateLabelBT: '(MM/ÁÁ)',
      cvv: 'CVV2',
      whatsThis: 'Hvað er þetta?',
    },
    'Portgual': {
      nameCard: 'Nome no cartão',
      cardType: 'Tipo de cartão',
      cardNumber: 'Número do cartão',
      expirationDate: 'Data de validade',
      monthDate: 'Mês',
      yearDate: 'Ano',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'O que é isto?',
    },
    'Brazil': {
      nameCard: 'Nome no cartão',
      cardType: 'Tipo de cartão',
      cardNumber: 'Número do cartão',
      expirationDate: 'Data de validade',
      monthDate: 'Mês',
      yearDate: 'Ano',
      expirationDateLabel: '(MM/AAAA)',
      expirationDateLabelBT: '(MM/AA)',
      cvv: 'CVV2',
      whatsThis: 'O que é isso?',
    },
  }